import Vue from 'vue'
import VueRouter from 'vue-router'
import layerView from '../views/layerView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/app/home'
  },
  {
    path: '/login',
    name: 'LOGIN',
    component:  () => import(/* webpackChunkName: "about" */ '../views/login.vue')
  },
  {
    path: '/app',
    component: layerView,
    children: [{
      path: 'home',
      name: '首页',
      component: () => import(/* webackChunkName: "ProductList" */ '../views/home')
    }]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
